<template>
  <div
    v-if="data && data.child"
    class="member-module"
  >
    <div
      v-for="(item, index) in data.child"
      v-show="item.fieldkey !== 'group' || joinTeamCascaderShow"
      :key="index"
      :class="['cascader-wrap', 'clearfix', item.fieldkey + '-cascader']"
    >
      <template v-if="item.fieldtype === 'string'">
        <a-form-item
          v-if="item.fieldkey === 'dev' || item.fieldkey === 'follow'"
          :label="item.fieldname"
        >
          <span class="truename">
            <em v-if="item.fieldkey === 'follow'">
              <span v-if="item.info.status === 0">{{ $t('message["394"]') }}</span>
              <span v-else-if="item.info.status === 2 || item.info.status === 4">{{ $t('message["139"]') }}</span>
              <span v-else-if="item.info.status === 3">{{ $t('message["146"]') }}</span>
              <span v-else>{{ item.info.truename || '- -' }}</span>
            </em>
            <em v-else>{{ item.info.truename || '- -' }}</em>
          </span>
          <!-- group -->
          <span
            v-if="item.info.rolename || item.info.groupname"
            class="fs-gray ml-8"
          >[<em class="rolename">{{ item.info.rolename || '--' }}</em> <em v-if="item.info.groupname && item.info.rolename">/</em> <em class="groupname">{{ item.info.groupname || '' }}</em>]</span>
        </a-form-item>
        <not-can-edit-item
          v-else
          :data="item"
        />
      </template>
      <!-- 跟进人员-多级选择 -->
      <template v-else-if="item.fieldkey === 'follow'">
        <my-cascader
          ref="followCascader"
          :value="currentFollowValue"
          :data="item"
          :get-data="getData"
          :input-truename="inputTruename"
          @change="handleChange"
        >
          <!-- 如果配置页面，开启共享，才展示 -->
          <div
            v-if="enableshare"
            class="share-box"
          >
            <a-checkbox
              :checked="isShared"
              :disabled="disabledShare"
              @change="onChangeShare(item, $event)"
            >
              {{ $t('message["1725"]') }}
            </a-checkbox>
            <span
              v-if="isShared"
              class="fs-gray"
            >{{ $t('message["1726"]') }}</span>
          </div>
          <div
            v-if="assignTeamInfo.length"
            slot="after"
            class="relate-list"
          >
            <p v-if="!isBeiAn">
              {{ $t('message["1456"]') }}{{ followTxt }}：
            </p>
            <a-radio-group
              v-model="assignRelateValue"
              @change="onChangeAssignRelate(item)"
            >
              <a-radio
                v-for="info in assignTeamInfo"
                :key="`${info.roleid}-${info.groupid}-${info.userid}`"
                :value="info.id"
              >
                <span v-if="info.rolename">{{ info.rolename }}</span>
                <span v-if="info.groupname">/{{ info.groupname }}</span>
                <!-- 分配方式文案 -->
                <span v-if="info.divide_type && info.type_num == 2">/{{ divides[info.divide_type] }}</span>
                <span v-if="info.truename"><em v-if="info.groupname">/</em>{{ info.truename }}</span>
              </a-radio>
            </a-radio-group>
          </div>
        </my-cascader>
      </template>
      <!-- 开发人员-多级选择 -->
      <template v-else-if="item.fieldkey === 'dev'">
        <my-cascader
          ref="devCascader"
          :value="currentDevValue"
          :data="item"
          :get-data="getData"
          :input-truename="inputTruename"
          @change="handleChange"
        >
          <div
            v-if="relateTeamInfo.length && !isClue && !(currentDevValue.length && currentDevValue[0].indexOf('null-') > -1)"
            slot="relate-list"
            class="relate-list"
          >
            <p>{{ $t('message["1457"]') }}：</p>
            <a-radio-group
              v-model="relateValue"
              @change="onChangeRelate(item)"
            >
              <a-radio
                v-for="info in relateTeamInfo"
                :key="`${info.roleid}-${info.groupid}-${info.userid}`"
                :value="info.id"
              >
                <span v-if="info.rolename">{{ info.rolename }}</span>
                <span v-if="info.groupname">/{{ info.groupname }}</span>
                <span v-if="info.truename">/{{ info.truename }}</span>
              </a-radio>
            </a-radio-group>
          </div>
        </my-cascader>
      </template>
      <!-- 所属团队小组-多级选择 -->
      <my-cascader
        v-else-if="item.fieldkey === 'group'"
        :value="currentGroupValue"
        :data="item"
        :get-data="getData"
        @change="handleChange"
      />
      <my-cascader
        v-else
        :data="item"
        :get-data="getData"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getJoinTeamInfo, getAuthTeamInfo } from '@/services/index'
import MyCascader from './../formItem/Cascader'
import NotCanEditItem from './../formItem/NotCanEdit'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    MyCascader,
    NotCanEditItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      joinTeamCascaderShow: true,
      relateValue: '',
      assignRelateValue: '',
      disabledShare: false,
      isShared: this.data.is_shared || false,
      currentDevValue: [],
      currentGroupValue: [],
      currentFollowValue: [],
      joinTeamCascaderInfo: {},
      divides: {
        1: this.$t('message["299"]'), // 分配到人
        2: this.$i18n.t('message["714"]'), // 平均分配
        3: this.$i18n.t('message["3"]'), // 按额度分配
        4: this.$i18n.t('message["1763"]') // 负责人指派
      }
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/detailData', ['isBeiAn']),
    ...mapState('inquery/relateData', ['relateTeamInfo', 'assignTeamInfo']),
    ...mapGetters('inquery/detailData', ['memberInfo']),
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    isCreatePage () {
      return this.$route.name === 'InqueryCreate'
    },
    isAuditPage () {
      return this.$route.name === 'InqueryDetail' && this.auditStatus !== 1
    },
    followTxt () {
      const { currentFollowValue } = this
      const type = currentFollowValue.find(item => item.indexOf('divide_type') > -1)
      const str = type ? type.split('-')[0] : ''
      if (str) {
        return str * 1 === 1 ? this.memberGroup[0] : this.memberGroup[1]
      } else {
        return this.memberGroup[0]
      }
    },
    memberGroup () {
      return this.$t('message["932"]').split('|')
    },
    inputTruename () {
      let inputTruename
      this.data.child.forEach((child = {}) => {
        if (child.fieldkey === 'input') {
          inputTruename = child.fieldvalue || ''
        }
      })
      return inputTruename
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    },
    isClue () {
      return this.$route.name === 'ClueCreate'
    }
  },
  watch: {
    // 来源关联人员
    relateTeamInfo: {
      handler (val) {
        this.relateValue = ''
        this.currentDevValue = []
        // 如果查询出的开发人员只有一条数据，默认选上
        this.data.child.forEach((item, i) => {
          if (item.fieldtype === 'cascader' && item.fieldkey === 'dev') {
            if (val.length === 1) {
              item.info = val[0]
              item.fieldvalue = this.setDefaultValue(item)
              this.relateValue = val[0].id
              this.currentDevValue = item.fieldvalue
            } else if (val.length > 1) {
              item.info = {}
              item.fieldvalue = []
              this.relateValue = ''
              this.currentDevValue = []
            } else if (val.length === 0) {
              item.fieldvalue = this.setDefaultValue(item)
              this.currentDevValue = item.fieldvalue
              this.relateValue = ''
            }
            this.data.child.splice(i, 1, item)
            this.$forceUpdate()
            this.$emit('change', item)
          }
        })
      },
      deep: true
      // immediate: true
    },
    // 信息分配规则关联
    assignTeamInfo: {
      handler (val) {
        this.assignRelateValue = ''
        if (!val || !val.length) return

        this.data.child.forEach((item, i) => {
          if (item.fieldtype === 'cascader' && item.fieldkey === 'follow') {
            // 如果查询出的跟进人员只有一条数据，默认选上这条关联人员
            item.fieldvalue = this.setDefaultValue(item)
            if (val.length === 1) {
              item.info = val[0]
              item.fieldvalue = this.setDefaultValue(item)
              this.currentFollowValue = item.fieldvalue
              this.assignRelateValue = val[0].id
            } else if (val.length > 1) {
              item.info = {}
              item.fieldvalue = []
              this.currentFollowValue = [] // 关联到的数据长度为0，或者大于1，清空选择
            } else if (val.length === 0) {
              item.fieldvalue = this.setDefaultValue(item)
              this.currentFollowValue = item.fieldvalue
              this.relateValue = ''
            }

            this.data.child.splice(i, 1, item)
            this.$emit('change', item)
          }
        })
        this.$forceUpdate()
      },
      deep: true
      // immediate: true // 去掉，勿改
    },
    data: {
      handler (val) {
        let { child = [] } = val || {}
        for (let item of child) {
          if (item.fieldtype === 'string' && item.fieldkey === 'inputName') {
            if (!item.fieldvalue) {
              item.fieldvalue = this.baseinfo && this.baseinfo.truename
            }
          } else if (item.fieldkey === 'group') {
            if (this.baseinfo && this.baseinfo.system_role === 1) {
              item.isneeded = 0
            } else { // 如果下拉没有数据，必填不生效
              item.isneeded = item.required !== undefined ? 0 : 1
            }
            // if (this.isClue) {
            //   item.isneeded = 1
            // }
          } else if (item.fieldkey === 'dev' && item.isBeiAn) {
            this.currentDevValue = item.fieldvalue
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  created () {
    eventBus.$on('updateFollowShare', this.updateFollowShare)
    eventBus.$on('clearCascaders', this.clearCascaders)
    // 审核页面 | 录入页
    if (this.$route.name === 'InqueryCreate' || (this.$route.name === 'InqueryDetail' && this.auditStatus !== 1)) {
      if (this.isBeiAn) { // 默认选择了备案时
        this.updateFollowShare(this.isBeiAn, true)
      }

      // 跟进人员 | 开发人员 有默认值时
      this.data.child.forEach((item, i) => {
        if (item.fieldtype === 'cascader') {
          item.fieldvalue = this.setDefaultValue(item)
          if (item.fieldkey === 'follow') {
            this.currentFollowValue = item.fieldvalue
          } else if (item.fieldkey === 'dev') {
            this.currentDevValue = item.fieldvalue
          }
        }
      })
    }
  },
  beforeDestroy () {
    eventBus.$off('updateFollowShare', this.updateFollowShare)
    eventBus.$off('clearCascaders', this.clearCascaders)
  },
  methods: {
    ...mapMutations('inquery/detailData', ['updataJoinTeamCascaderShow']),
    async getData (obj = {}) {
      let { fieldkey, type } = obj
      let params = {}
      let result
      if (type) { // 共享
        params.type = type
      }
      if (fieldkey === 'group') { // 所属团队小组
        if (this.auditStatus === 0 || this.auditStatus === -1 || this.from === 'audit') {
          params.pk = 'inquiry-audit'
        } else if (this.isClue) {
          // clue-manage
          params.pk = 'clue-add'
          // params.userid = this.data.child.filter(item => item.info && item.info.userid)[0].info.userid
        } else {
          params.pk = 'inquiry-add'
        }

        if (this.isClue) {
          result = await getJoinTeamInfo()
            .params(params).fetch()
        } else {
          result = await getJoinTeamInfo()
            .params(params).fetch()
        }
      } else if (fieldkey === 'dev') { // 开发人员
      // clue-manage'
        params.pk = this.isClue ? 'clue-followup' : 'inquiry-dev'
        params.deal = 1 // 去除空组和空团队

        result = await getAuthTeamInfo()
          .params(params).fetch()
      } else if (fieldkey === 'follow') { // 跟进人员
        params.pk = 'inquiry-followup'

        if (!this.isShared && !this.isBeiAn) {
          params.divide = 1 // 出现四列
        }

        // 非共享，如果选择了共享，审核页面要默认展示录入时选择的值
        if (!this.isShared) {
          params.deal = 1 // 去除空组和空团队
        }
        // 审核页面，如果选择了共享，并且共享开启type=1
        if (this.isShared && this.enableshare) {
          params.type = 1
        }

        result = await getAuthTeamInfo()
          .params(params).fetch()
      }

      let { payload: data = [] } = (result && result.data) || {}

      // console.log(data)

      if (fieldkey === 'group') {
        this.joinTeamCascaderShow = !!data.length
        this.updataJoinTeamCascaderShow(this.joinTeamCascaderShow)
        // 如果所属团队与小组人员只有一条数据，默认选上
        if (data.length === 1 && data[0].children && data[0].children.length === 1) {
          this.data.child.forEach((item, i) => {
            // 团队小组如果选择了，fieldvalue长度是大于2，长度等于已的情况是进入了审核详情，默认有审核人员userid
            if (item.fieldkey === 'group' && item.fieldvalue.length < 2) {
              let res = {}
              item.info = this.setFirstAsValue(res, data[0])
              item.fieldvalue = this.setDefaultValue(item)
              this.currentGroupValue = item.fieldvalue
              this.joinTeamCascaderInfo = item.info
              this.$emit('change', item)
            }
          })
        } else if (!data.length) { // 如果人员的数据为空数组，且是团队管理
          this.data.child.forEach((item, i) => {
            if (item.fieldkey === 'group') {
              item.required = 0
              this.$emit('change', item)
            }
          })
        }
      }
      /* else if (fieldkey === 'dev') {
        // 开发人员过滤空组
        this.setGroupEmpty(data)
        this.setRoleEmpty(data)
      } else if (fieldkey === 'follow') {
        if (this.isBeiAn) {
          // 如果跟进人员，选择了备案，即使再选择共享，还是可以选择到人
          this.setGroupEmpty(data)
          this.setRoleEmpty(data)
        }
        if (!this.isShared) {
          this.setDivideGroupEmpty(data)
        }
        if (!this.isBeiAn && !this.isShared) {
          // 如果没有选备案，也没选共享，需要判断分配方式
          this.setFollowData(data
        }
      } */
      if (fieldkey === 'dev' && !this.isClue) {
        data = [{
          id: 'null',
          keyname: 'roleid',
          name: '-' + this.$t('message["1723"]') + '-' // -无-
        }].concat(data)
      }
      if (fieldkey === 'follow' && !this.isBeiAn && !this.isShared) {
        // 如果没有选备案，也没选共享，需要判断分配方式
        this.setFollowData(data)
        data = [{
          id: 'null',
          keyname: 'roleid',
          name: '-' + this.$t('message["1724"]') + '-' // -暂不分配-
        }].concat(data)
      }

      return data
    },

    /**
     * 设置第一项的数据为value
     */
    setFirstAsValue (res = {}, data = {}) {
      res[data.keyname] = data.id

      if (data.children && data.children.length) {
        this.setFirstAsValue(res, data.children[0])
      }
      return res
    },

    /* 每一项操作后把值传到父级 */
    handleChange (data) {
      this.$emit('change', data)
      if (data.fieldkey === 'dev') {
        this.relateValue = ''
      } else if (data.fieldkey === 'follow') {
        this.assignRelateValue = ''
      }
    },

    /**
     * 当分配方式是包含1，选到人，不是包含1，删除掉人的 children 数据，divide_type是数组
     */
    setFollowData (data) {
      for (let item of data) {
        if (item.hasOwnProperty('divide_type') && item.divide_type.length === 1 && item.divide_type[0] !== 1) {
          item.children = []
        }
        if (item.children && item.children.length) {
          this.setFollowData(item.children)
        }
      }
    },
    /**
     * 当选择了备案，忽略分配方式，并且置灰没有人的组
     */
    /* setGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setGroupEmpty(item.children)
        }
      }
    }, */
    /* setRoleEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'roleid' && (!item.children || !item.children.length)) {
          data.splice(i, 1)
        }
      }
    }, */
    /**
     * 删除 divide_type 为 1 的 空组，1代表分配到人
     */
    /* setDivideGroupEmpty (data) {
      for (let len = data.length, i = len - 1; i >= 0; i--) {
        let item = data[i]
        if (item.keyname === 'groupid' && item.divide_type.length === 1 && item.divide_type[0] === 1 && (!item.children || !item.children.length)) {
          // item.disabled = true
          data.splice(i, 1)
        }
        if (item.keyname === 'roleid' && (item.children && item.children.length)) {
          this.setDivideGroupEmpty(item.children)
        }
      }
    }, */

    onChangeShare (item, e) {
      this.isShared = e.target.checked
      this.data.is_shared = this.isShared
      this.updateFollowOptions(item, this.isShared)
      this.assignRelateValue = ''
    },

    /**
     * 切换选择到组和人的数据
     */
    updateFollowOptions (item, isShared) {
      this.$nextTick(async () => {
        if (this.$refs.followCascader && this.$refs.followCascader[0]) {
          this.$refs.followCascader[0].clearCascader()
          item.info = {}
          item.fieldvalue = []

          let type = isShared ? 1 : 0
          let data = await this.getData({ fieldkey: 'follow', type })
          item.options = data
          this.$refs.followCascader[0].updateFollowOptions(data, isShared)
        }
      })
    },
    onChangeRelate (item) {
      this.relateTeamInfo.forEach(info => {
        if (info.id === this.relateValue) {
          item.fieldvalue = this.setDefaultValue({ info })
          item.info = info
          this.currentDevValue = item.fieldvalue
        }
      })
    },
    onChangeAssignRelate (item) {
      console.log(this.assignRelateValue, this.assignTeamInfo)
      this.assignTeamInfo.forEach(info => {
        if (info.id === this.assignRelateValue) {
          item.fieldvalue = this.setDefaultValue({ info })
          item.info = info
          this.currentFollowValue = item.fieldvalue
        }
      })
    },
    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {} } = item

      let { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, type_num: typeNum } = info

      // 如果是审核页面
      // 审核页的录入人员不是万能表单
      if ((this.isAuditPage && this.inputTruename.indexOf('万能表单自动录入') === -1) && !roleid && !userid) {
        roleid = 'null'
      }
      if (roleid) {
        arr.push(`${roleid}-roleid`)
      }
      if (groupid) {
        arr.push(`${groupid}-groupid`)
      }
      /* if (userid) {
        arr.push(`${userid}-userid`)
      } */
      // typeNum: 有几种分配方式
      // divideType：具体的分配方式
      if (typeNum) {
        if (divideType === 1 && typeNum >= 2 && userid) { // 四级
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && (!divideType || typeNum === 1)) { // 负责人
          arr.push(`${userid}-userid`)
        } else if (divideType) { // 到分配方式
          arr.push(`${divideType}-divide_type`)
        }
      } else {
        if (divideType === 1 && userid) { // 四级
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && !divideType) { // 负责人
          arr.push(`${userid}-userid`)
        } else if (divideType) { // 到分配方式
          arr.push(`${divideType}-divide_type`)
        }
      }

      return arr
    },
    /**
     * val: 是否选择了备案
     * type: 如果审核页面默认选择了备案，type = true，如果点击共享选择，type 为 undefind
     *
     * 选择了备案，清空选择的共享，数据
     */
    updateFollowShare (val, type) {
      if (val) {
        this.isShared = false
        this.data.is_shared = false
        this.disabledShare = true
      } else {
        this.disabledShare = false
      }

      if (!type) { // 手动点击共享时，才清空跟进人员选择的结果
        const { child = [] } = this.data
        const item = child.find(item => item.fieldkey === 'follow')
        this.updateFollowOptions(item, false)
        this.$forceUpdate()
      }
    },
    /* clearDevCascader () {
      this.data.child.forEach((item, i) => {
        if (item.fieldkey === 'dev') {
          item.info = {}
          item.fieldvalue = []
          this.currentDevValue = []
        }
      })
    } */
    clearCascaders (key) {
      this.data.child.forEach((item, i) => {
        if (item.fieldkey === key) {
          item.info = {}
          item.fieldvalue = []
        }
        if (key === 'dev') {
          this.currentDevValue = []
        }
        if (key === 'group') {
          this.currentGroupValue = []
        }
        if (key === 'follow') {
          this.currentFollowValue = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.member-module {
  .cascader-wrap {
    margin-bottom: 24px;
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .ant-checkbox-wrapper {
    margin-right: 0;
  }
  .ant-radio-wrapper {
    display: block;
  }

  ::v-deep .ant-form-explain {
    position: absolute;
    top: 34px;
    left: 0;
  }
  .follow-cascader ::v-deep {
    .ant-form-explain {
      left: 0;
      top: auto;
      bottom: -20px;
    }
  }

  em {
    font-style: normal;
  }
  .relate-list {
    overflow: hidden;
    padding-top: 10px;
  }
}
</style>
